document.addEventListener('DOMContentLoaded', function() {
  const widgets = document.querySelectorAll('.standings-widget');

  widgets.forEach(function(widget) {
    const fullTableLink = widget.querySelector('.full-table-link');
    const standingsBody = widget.querySelector('.standings-body');
    
    if (fullTableLink && standingsBody) {
      const allRows = standingsBody.querySelectorAll('.standings-row');
      const allDividers = standingsBody.querySelectorAll('.standings-divider');
      
      // Function to determine teams per page based on viewport
      function getTeamsPerPage() {
        if (standingsBody.classList.contains('has-countdown')) {
          return 4;
        }
        return window.innerWidth <= 1199 ? 4 : 8; // mobile = 4, desktop = 8
      }

      let teamsPerPage = getTeamsPerPage();
      const totalTeams = allRows.length;
      let totalPages = Math.ceil(totalTeams / teamsPerPage);
      let currentPage = 0;

      function showPage(page) {
        const startIndex = page * teamsPerPage;
        const endIndex = Math.min(startIndex + teamsPerPage, totalTeams);
        
        allRows.forEach(row => row.classList.add('hidden-standing'));
        allDividers.forEach(divider => divider.classList.add('hidden-standing'));

        for (let i = startIndex; i < endIndex; i++) {
          allRows[i]?.classList.remove('hidden-standing');
          if (i < endIndex - 1 && allDividers[i]) {
            allDividers[i].classList.remove('hidden-standing');
          }
        }
      }

      function updateButtonText() {
        if (currentPage === totalPages - 1 && totalPages > 1) {
          fullTableLink.textContent = 'BACK TO TOP';
        } else {
          fullTableLink.textContent = `NEXT ${teamsPerPage} TEAMS`;
        }
      }

      if (totalPages > 1) {
        fullTableLink.addEventListener('click', function(e) {
          e.preventDefault();
          standingsBody.style.opacity = '0';
          
          setTimeout(function() {
            currentPage = (currentPage + 1) % totalPages;
            showPage(currentPage);
            updateButtonText();
            standingsBody.scrollTop = 0;
            standingsBody.style.opacity = '1';
          }, 300);
        });
      }

      // Initialize display
      showPage(0);
      updateButtonText();
    }
  });
});
